<template>
  <div>
    <generic-container
      :title="$t('student information')"
      icon="student"
      :header_buttons="header_buttons"
    >
      <h2 class="ui center aligned header">
        <img src="/images/icons/matthew.png" class="ui circular image" />
        <div class="content">
          {{ student.name }}
          <div class="sub header">
            {{ $t("registered") }}
            {{
              student.create_date
                | formatDate(
                  enterprise_setup ? enterprise_setup.detailed_date_format : "",
                )
            }}
          </div>
        </div>
      </h2>

      <div class="ui two item top attached tabular menu">
        <a class="active item" data-tab="general">
          <i class="info icon"></i>
          {{ $t("general information") }}
        </a>
        <!-- <a class="item" data-tab="inscriptions">
          <i class="signature icon"></i>
          {{ $t("inscriptions") }}
        </a>-->
        <!-- <a class="item" data-tab="account">
          <i class="money icon"></i>
          {{ $t("account") }}
        </a>-->
        <a class="item" data-tab="courses">
          <i class="student icon"></i>
          {{ $t("courses") }}
        </a>
        <!-- <a class="item" data-tab="documents">
          <i class="file icon"></i>
          {{ $t("documents") }}
        </a>-->
      </div>
      <div class="ui bottom attached active tab segment" data-tab="general">
        <general-info :setup="student.setup"></general-info>
      </div>
      <!-- <div class="ui bottom attached tab segment" data-tab="inscriptions">
        <inscriptions :student_uuid="student.uuid"></inscriptions>
      </div>-->
      <!-- <div class="ui bottom attached tab segment" data-tab="account">
        <account :student_uuid="student.uuid"></account>
      </div>-->
      <div class="ui bottom attached tab segment" data-tab="courses">
        Fourth
      </div>
      <!-- <div class="ui bottom attached tab segment" data-tab="documents">
        <documents :student_in="student"></documents>
      </div>-->
      <!-- <pre>{{ student }}</pre> -->
    </generic-container>
    <component
      :is="submodule.setup.plugin.component"
      :module="submodule"
      :student_in="student"
      v-for="(submodule, index) in submodules"
      v-bind:key="index"
    ></component>
    <template v-for="(mdl, index) in student_modals">
      <component
        :is="mdl"
        :key="index"
        :student_uuid="student.uuid"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import {
  local_api,
  clone,
  error_toast,
  load_submodules,
  enterprise_setup,
} from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import StudentModal from "../StudentModal";
import GeneralInfo from "./GeneralInfo";
// import Inscriptions from "./Inscriptions";
// import Account from "./Account";
// import Documents from "./Documents";
import StudentDocumentPlugin from "@/modules/student_document/StudentDocumentPlugin";
import StudentInscriptionPlugin from "@/modules/student_inscription/StudentInscriptionPlugin";
import StudentScolarshipPlugin from "@/modules/student_scolarship/StudentScolarshipPlugin";
import StudentAccountPlugin from "@/modules/student_account/StudentAccountPlugin";

// @ is an alias to /src
export default {
  name: "StudentView",
  components: {
    "generic-container": GenericContainer,
    // Documents,
    GeneralInfo,
    // Inscriptions,
    // Account,
    StudentDocumentPlugin,
    StudentAccountPlugin,
    StudentInscriptionPlugin,
    StudentScolarshipPlugin,
  },
  props: { student_uuid: String },
  filters: filters,
  data() {
    return {
      student: { setup: {} },
      configuration: {},
      header_buttons: [
        {
          color: "orange",
          icon: "edit",
          click: this.edit_student,
        },
        {
          color: "red",
          icon: "trash",
          click: this.remove_student,
        },
      ],
      submodules: [],
      student_modals: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    decode_gender(value) {
      if (value == "m") return this.$t("male");
      else if (value == "f") return this.$t("female");
      else if (value == "u") return this.$t("undefined");
    },
    decode_civil_status(value) {
      if (value == "m") return this.$t("married");
      else if (value == "s") return this.$t("single");
    },
    remove_student() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove student?"),
        function() {
          local_api(vm, "post", "/student/do-remove", { u: vm.student.uuid })
            .then(() => {
              vm.$router.push({
                name: "StudentIndex",
              });
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    edit_student() {
      this.student_modals.push(StudentModal);
    },
    succedded(data) {
      try {
        data.setup = JSON.parse(data.setup);
        this.student = data;
      } catch (error) {
        console.error("error parsing JSON".error);
      }
    },
    destroy() {
      this.student_modals = [];
    },
  },
  mounted() {
    let vm = this;

    load_submodules(vm, "student");

    let student_uuid = this.$route.query.i;
    if (student_uuid) {
      local_api(vm, "post", "/student/do-get", { u: student_uuid })
        .then((student) => {
          vm.student = student;
        })
        .catch((err) => {
          error_toast(err);
        });
    } else {
      error_toast(this.$t("no student"));
    }

    window.jQuery(".ui.menu .item").tab();
  },
  watch: {
    filter() {
      if (this.filter == "") this.display_modules = clone(this.modules);
      else
        this.display_modules = this.modules.filter(
          (n) =>
            this.$i18n
              .t(n.sys_module.setup.name.toUpperCase())
              .includes(this.filter.toUpperCase()) ||
            this.$i18n
              .t(n.sys_module.setup.description.toUpperCase())
              .includes(this.filter.toUpperCase()),
        );
    },
  },
};
</script>

<style>
.statistics .statistic {
  margin: 20px auto !important;
}
</style>
